module.exports = __webpack_public_path__ + "static/img/img_file.f182f158.png";